import React, { useState } from 'react';
import { Offcanvas, Button, Tab, Tabs, Dropdown } from 'react-bootstrap';
import ProposalContent from '../ProposalContent';
import CommentContent from '../CommentContent';
import TaskContent from '../TaskContent';
import { MdEmail, MdEdit, MdPictureAsPdf } from "react-icons/md";

const ViewProposalModal = ({ show, handleClose }) => {
    const [activeTab, setActiveTab] = useState('proposal');

    return (
        <Offcanvas show={show} onHide={handleClose} placement="end" scroll={true} className="w-50">
            <Offcanvas.Header className="d-flex justify-content-between align-items-center">
                <Offcanvas.Title>Proposal</Offcanvas.Title>

                {/* Top-right Close Button */}
                <Button variant="light" className="btn-close" onClick={handleClose}></Button>
            </Offcanvas.Header>

            <Offcanvas.Body>
                {/* Responsive Button Group */}
                <div className="d-flex flex-wrap gap-1">
                    <Dropdown>
                        <Dropdown.Toggle size="sm">Convert</Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#">Invoice</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Button size="sm" title='Send Email'><MdEmail /></Button>
                    <Button size="sm" title='Edit'><MdEdit /></Button>

                    <Dropdown>
                        <Dropdown.Toggle size="sm"><MdPictureAsPdf /></Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#">View PDF</Dropdown.Item>
                            <Dropdown.Item href="#">Download</Dropdown.Item>
                            <Dropdown.Item href="#">Print</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>

                    <Dropdown>
                        <Dropdown.Toggle size="sm">More</Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="#">View Proposal</Dropdown.Item>
                            <Dropdown.Item href="#">Mark as Sent</Dropdown.Item>
                            <Dropdown.Item href="#">Mark as Open</Dropdown.Item>
                            <Dropdown.Item href="#">Mark as Revised</Dropdown.Item>
                            <Dropdown.Item href="#">Mark as Declined</Dropdown.Item>
                            <Dropdown.Item href="#">Mark as Accepted</Dropdown.Item>
                            <Dropdown.Item className="text-danger" href="#">Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>

                {/* Tabs Section */}
                <Tabs
                    id="proposal-tabs"
                    activeKey={activeTab}
                    onSelect={(key) => setActiveTab(key)}
                    className="mb-3"
                >
                    <Tab eventKey="proposal" title="Proposal">
                        <ProposalContent />
                    </Tab>

                    <Tab eventKey="task" title="Task">
                        <TaskContent />
                    </Tab>

                    <Tab eventKey="comments" title="Comments">
                        <CommentContent />
                    </Tab>

                    <Tab eventKey="notes" title="Notes">
                        <p>This is the Notes content.</p>
                    </Tab>

                    <Tab eventKey="reminders" title="Reminders">
                        <p>This is the Reminders content.</p>
                    </Tab>
                </Tabs>

                {/* Footer Close Button */}
                <div className="mt-3 text-end">
                    <Button variant="danger" size="sm" onClick={handleClose}>Close</Button>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    );
};

export default ViewProposalModal;
